import { inject, injectable } from "@launchtray/tsyringe-async";
import { Language } from "../../common/Language";
import { GameModel } from "../../game/models/game/GameModel";
import { PlayerController } from "../../game/controllers/PlayerController";
import { Localization } from "../../common/Localization";
import { SceneManager } from "scene-manager";
import { InjectableFactories, RetrySceneFactory } from "../../../composition/InjectableFactories";
import { AudioManager } from "../../../audio/AudioManager";

@injectable()
export class SettingsController {
    public constructor(
        private readonly playerController: PlayerController,
        private readonly gameModel: GameModel,
        private readonly localization: Localization,
        private readonly sceneManager: SceneManager,
        @inject(InjectableFactories.RetrySceneFactory) private readonly retrySceneFactory: RetrySceneFactory,
        private readonly audioManager: AudioManager,
    ) {
    }

    public switchSounds(isOn: boolean): void {
        this.audioManager.isPlaySounds = isOn;
    }

    public switchMusic(isOn: boolean): void {
        this.audioManager.isPlayMusic = isOn;
    }

    public changeLocalization(locale: Language): void {
        this.localization.locale = locale;
    }

    public async retryGame(): Promise<boolean> {
        const retryPopup = await this.retrySceneFactory();
        const result = await this.sceneManager.showViewableAsync(retryPopup);
        if (result) {
            this.playerController.resetRevivals();
            this.gameModel.deckModel.removeSpecialFigure();
            this.playerController.resetBoosters();
            this.gameModel.deckModel.shuffle();
            this.gameModel.clearGamefield();
            this.playerController.resetScore();
        }
        return result;
    }
}